import { ChangePhoneTrackingPoint } from '@shopee-user/tracking-constants';

import { PageType } from '../constants';

const ChangePhoneTrackingSchema: Record<ChangePhoneTrackingPoint, string> = {
  [ChangePhoneTrackingPoint.ChangePhoneSuccessAction]: '',
  [ChangePhoneTrackingPoint.ChangePhoneFailAction]: '',
  [ChangePhoneTrackingPoint.ChangePhoneRateLimitPopupImpression]: '',
};

export const getChangePhonePageTypeAndSchema = (
  trackingPoint: ChangePhoneTrackingPoint
) => {
  return {
    page_type: PageType.ChangePhonePage,
    schema: ChangePhoneTrackingSchema[trackingPoint],
  };
};
